export const ENV = {
  USERPOOL_ID: 'us-east-2_hIkKERM8V',
  CLIENT_ID: 'lrg2gh6ftvst0c79c20sh6as6',
};
